// Shared by every pending/approved/rejected request panel in this feature
// (UpdateRequestsPanel, LeaveRequestsPanel) — previously each redefined its
// own identical copy of both constants.
export const REQUEST_STATUS_STYLES: Record<string, string> = {
  pending: "bg-amber-500/10 text-amber-400",
  approved: "bg-emerald-500/10 text-emerald-400",
  rejected: "bg-red-500/10 text-red-400",
};

export const REQUEST_STATUS_FILTERS = ["pending", "approved", "rejected", ""];
